const BASE_OFFLINE_PRODUCT_STRUCTURE = {
  brand: "",
  category_id: "pro_cat_m_01HCFCA4KCAC2E3WYTW7JB1R6WA002",
  countries: {
    iso_2: "ae",
  },
  description: "",
  hs_code: "",
  images: [
    {
      metadata: {
        default_image: true,
      },
      url: "https://minio.app.watermelon.market/wm-static-images/product-icons/1701945938161-default-product.png",
    },
  ],
  is_vat_included: false,
  metadata: {
    attributes: {},
    certifications: [],
    product_details: [],
  },
  product_code: "",
  sub_category_id: "pro_sub_cat_m_01HCFCA4KCYRFP6DHF27SR84P3B016",
  sub_sub_category_id: "pro_child_cat_m_01HCFCA4KCG2GMZQ0Q6X8YY4TKC102",
  tags: [],
  title: "",
  variants: [
    {
      metadata: {
        offer: 0,
        ordering_option_id: "pro_unit_m_01HD5NKE2MJKCJMVBS5PYQ9AA15",
        ordering_option_label: "Pieces",
        ordering_option_value: 1,
        secondary_ordering_option_id: "pro_unit_m_01HD5NKE2MJKCJMVBS5PYQ9AA15",
        secondary_ordering_option_label: "Pieces",
        secondary_ordering_option_value: 1,
        vat_percentage: "5",
      },
      min_quantity: 1,
      title: "",
      unit_price: "",
    },
  ],
};

function getOMSProductFromBaseStructure({
  title,
  unit_price,
}: {
  title: string;
  unit_price: string;
}) {
  const productStructure = JSON.parse(
    JSON.stringify(BASE_OFFLINE_PRODUCT_STRUCTURE)
  );
  productStructure.title = title;
  productStructure.variants[0].title = title;
  productStructure.variants[0].unit_price = unit_price;
  return productStructure;
}

export { getOMSProductFromBaseStructure };
